module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_c('nav', [_c('ul', {
    staticClass: "question-links-container"
  }, _vm._l((_vm.problems), function(value, key) {
    return _c('li', {
      staticClass: "question-link"
    }, [_c('router-link', {
      attrs: {
        "to": '/source/' + key
      }
    }, [_vm._v(_vm._s(key) + "." + _vm._s(_vm.problems[key]['title']))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75275920!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SideBar.vue
// module id = 126
// module chunks = 2